import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {PatientDTOModel} from '../../models/patientDTO.model';

@Component({
    selector: 'patient-info',
    templateUrl: './patient-info.component.html',
    styleUrls: ['./patient-info.component.scss'],
})
export class PatientInfoComponent implements OnInit {

    @Input() document: DocumentModel;

    constructor() {
    }

    ngOnInit() {
        if (!this.document.patient) {
            this.document.patient = new PatientDTOModel();
        }
    }

}
